import FormattedMessage from 'I18n/components/FormattedMessage';
import { ConfirmModal } from 'foundations-components/transitional/components/ConfirmModal';
import { jsx as _jsx } from "react/jsx-runtime";
const RetakePracticalExerciseModal = ({
  disableConfirm,
  onConfirm,
  onReject
}) => /*#__PURE__*/_jsx(ConfirmModal, {
  confirmLabel: /*#__PURE__*/_jsx(FormattedMessage, {
    "data-test-id": "practical-exercise-retake-modal-ok",
    message: "learningCenter.practicalExercise.retryModal.confirmLabel"
  }),
  "data-test-id": "practical-exercise-retake-modal",
  description: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "learningCenter.practicalExercise.retryModal.description"
  }),
  disableConfirm: disableConfirm,
  message: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "learningCenter.practicalExercise.retryModal.message"
  }),
  onConfirm: onConfirm,
  onReject: onReject,
  rejectLabel: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "learningCenter.practicalExercise.retryModal.rejectLabel"
  })
});
export default RetakePracticalExerciseModal;